import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import { motion } from "framer-motion";


const ContactMeForm = () => {
    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();
        console.log(form.current);
        emailjs.sendForm("service_u95t31t", "template_d8n0heq", form.current, "QTjGqW1LLi9_qtjeU")
            .then((result) => {
                console.log(result.text);
            }, (error) => {
                console.log(error.text);
            });
        form.current.reset();
    }
    return (
        <div className='w-full lg:w-2/3 mx-auto'>
            <div className="hero my-24">
                <div className="hero-content flex-col lg:flex-row-reverse">
                    <div className="text-center lg:text-left font-mono">
                        <h1 className="text-5xl font-bold text-white">Contact Me</h1>
                        <p className="py-6 text-white text-3xl">I'm open to suggestion. If you have any for me or you just need to tell me something, just put your name, email, message and hit the Send Message button!</p>
                    </div>
                    <div className="card flex-shrink-0 w-full max-w-sm shadow-2xl bg-transparent">
                        <div className="card-body">
                            <div className=''>
                                <form ref={form} action="" className='form-control' onSubmit={sendEmail}>
                                    <input type="text" name='user_name' placeholder="Your Name" className="input input-bordered w-full max-w-xs mb-2" />
                                    <input type="email" name='user_email' placeholder="Your Email" className="input input-bordered w-full max-w-xs mb-2" />
                                    <input type="text" name='subject' placeholder="Subject" className="input input-bordered w-full max-w-xs mb-2" />
                                    <textarea name='message' className="textarea textarea-bordered mb-2" placeholder="Your Message"></textarea>
                                    <input className='btn btn-ghost text-white border-white' type="submit" value="Send Message" />
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactMeForm;